import { ReactElement } from 'react'
import { useParams } from 'react-router-dom'
import invariant from 'tiny-invariant'
import { Spin } from 'antd'

import { AuthUserParticipantContextProvider } from '../common/Participation'
import { ParticipationInvalidResult } from '../common/ParticipationInvalidResult'

import { useLoadDecision } from '../../redux/hooks'
import { useAccount } from '../../context'
import { Participation } from '../common/Participation/Participation'
import { useResolvedParticipationSessionId } from '../../hooks/useResolvedParticipationSessionId'

export const ParticipationPage = (): ReactElement => {
  const { accountId } = useAccount()
  const { decisionId, participationSessionId: idOrSlug } = useParams<'decisionId' | 'participationSessionId'>()
  invariant(decisionId, 'decisionId required in URL parameters')
  invariant(idOrSlug, 'participationSessionId required in URL parameters')

  // The route param may be a short slug; resolve it to a participation-session id first.
  const { participationSessionId, loading: resolvingSlug, notFound } = useResolvedParticipationSessionId(
    decisionId,
    idOrSlug
  )
  const loading = useLoadDecision(accountId, decisionId)

  if (resolvingSlug || loading) return <Spin />
  if (notFound || !participationSessionId) {
    return <ParticipationInvalidResult subTitle="The link may have been replaced with a new one." />
  }

  return (
    <AuthUserParticipantContextProvider decisionId={decisionId}>
      <Participation decisionId={decisionId} participationSessionId={participationSessionId} />
    </AuthUserParticipantContextProvider>
  )
}
